var isGoogleMapsReady = () => {
  var _window, _window$google;
  return !!((_window = window) !== null && _window !== void 0 && (_window$google = _window.google) !== null && _window$google !== void 0 && _window$google.maps && window.google.maps.Geocoder && window.google.maps.places);
};
var loadGmaps = callback => {
  var existingScript = document.getElementById("gmapsJS");
  if (isGoogleMapsReady()) {
    if (callback) callback();
    return;
  }
  if (!existingScript) {
    var script = document.createElement("script");
    script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBPUWIKrkaiq6h9K94O-twab-IT7WY_67s&libraries=places";
    script.id = "gmapsJS";
    script.onload = () => {
      script.setAttribute("data-loaded", "true");
      if (callback) callback();
    };
    document.body.appendChild(script);
    return;
  }
  if (existingScript.getAttribute("data-loaded") === "true") {
    if (callback) callback();
    return;
  }
  if (callback) {
    existingScript.addEventListener("load", callback, {
      once: true
    });
  }
};
export default loadGmaps;